import React from 'react';
import { NavigationCard } from '@weirgroup/one-weir';
import styles from './Hub.module.css';

/**
 * Common component to display list of internal and external apps
 * @param  props : data, className, title, subTitle
 */
export default function AppData(props) {
  const { data, className, title, subTitle } = props;

  return (
    <div className={className} data-testid={className}>
      <div className={styles.appTitle}>{title}</div>
      <div className={styles.appSubheader}>{subTitle}</div>
      <div className={styles.row} data-testid="app-data-row">
        {data &&
          data.length > 0 &&
          data.map((data, index) => {
            return (
              <div
                key={index}
                className={styles.col}
                data-testid="app-data-col"
              >
                <NavigationCard
                  sideBarColor={data.borderLeftColor}
                  imageUrl={data.imageUrl}
                  title={data.title}
                  description={data.description}
                  redirectTo={data.redirectionUrl}
                  onClick={props.onClick}
                  disabled={data.disabled}
                />
              </div>
            );
          })}
      </div>
    </div>
  );
}
